import { ITranslation } from '../ITranslation';

export class GermanTranslation implements ITranslation {
  public language = 'de';
  public dataLoadingFailureMessage = 'Ein Fehler ist aufgetreten. Bitte laden Sie die Seite neu.';
  public newElement = 'Neues Element';
  public add = 'Hinzufügen';
  public cancel = 'Abbrechen';
  public confirmDeletion = 'Wollen Sie das ausgewählte Element wirklich löschen?';
  public invalidValue = 'Bitte gültigen Wert eingeben.';
  public sorting = 'Sortieren';
  public sortingAscending = 'Aufsteigend';
  public sortingDescending = 'Absteigend';
  public sortingThenAscending = 'Aufsteigend hinzufügen';
  public sortingThenDescending = 'Absteigend hinzufügen';
  public columns = 'Spalten';
  public moveColumnLeft = 'Spalte nach links';
  public moveColumnRight = 'Spalte nach rechts';
  public hideColumn = 'Spalte ausblenden';
  public showColumn = 'Spalte einblenden';
  public filter = 'Filter';
  public equals = 'Ist gleich';
  public notEquals = 'Ist nicht gleich';
  public contains = 'Enthält';
  public isEmpty = 'Ist leer';
  public isNotEmpty = 'Ist nicht leer';
  public before = 'Vor';
  public after = 'Nach';
  public between = 'Zwischen';
  public yes = 'Ja';
  public no = 'Nein';
  public ok = 'OK';
  public filterText = 'Filtertext';
}
